(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PortalRoleDialogController', PortalRoleDialogController);

    PortalRoleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PortalRole'];

    function PortalRoleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PortalRole) {
        var vm = this;

        vm.portalRole = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.portalRole.id !== null) {
                PortalRole.update(vm.portalRole, onSaveSuccess, onSaveError);
            } else {
                PortalRole.save(vm.portalRole, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:portalRoleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
